<template>
  <div>
    <v-row>
      <v-col cols="12">
        <h4 class="secondary--text mb-3">
          {{
            $t(
              'fleet_management.geofences.create_geofence.labels.form_sub_title'
            )
          }}
        </h4>
        <h5 class="tertiary--text">
          {{
            $t(
              'fleet_management.geofences.create_geofence.labels.coordinates_hint'
            )
          }}
        </h5>
      </v-col>
    </v-row>

    <v-row>
      <v-col md="3">
        <v-text-field
          v-model.number="latitude"
          dense
          filled
          hide-details="auto"
          @input="updateLatitude"
          :label="
            $t('fleet_management.geofences.create_geofence.labels.latitude')
          "
          placeholder="-90 / 90"
          required
          ref="latitude"
          color="tertiary"
          :rules="[coordinatesRules.latitude]"
        />
      </v-col>
      <v-col md="3">
        <v-text-field
          v-model.number="longitude"
          dense
          filled
          hide-details="auto"
          @input="updateLongitude"
          :label="
            $t('fleet_management.geofences.create_geofence.labels.longitude')
          "
          placeholder="-180 / 180"
          required
          color="tertiary"
          :rules="[coordinatesRules.longitude]"
          ref="longitude"
        />
      </v-col>
      <v-col md="3">
        <v-text-field
          v-model.number="radius"
          dense
          :error-messages="radiusError"
          filled
          hide-details="auto"
          @input="updateRadius"
          :label="
            $t('fleet_management.geofences.create_geofence.labels.radius')
          "
          required
          color="tertiary"
          :rules="[radiusRules.required, radiusRules.format, radiusRules.range]"
          ref="radius"
        />
      </v-col>
      <v-col align-self="center" md="3" class="text-right">
        <v-btn
          id="idBtnZonasReset"
          @click="resetCircleParams"
          outlined="true"
          color="secondary"
          rounded
          >{{
            $t(
              'fleet_management.geofences.create_geofence.labels.form_new_geofence_reset_button'
            )
          }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { GEOFENCE_MIN_RADIUS, GEOFENCE_MAX_RADIUS } from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'
import { GeofencesHelpers, MapHelpers } from '@/helpers/mainExports.js'
import { mapActions } from 'vuex'

export default {
  name: 'CircleZone',

  data() {
    return {
      circle: null,
      coordinatesRules: {
        latitude: value => {
          const regex = /^(\+|-)?(?:90(?:(?:\.0{1,7})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,7})?))$/
          const result = regex.test(value)
          //Si no cumple con el formato de coordenada, verifico que sea un número real lo ingresado
          if (!result) {
            const isNumberRegex = /^-?[0-9]\d*(\.\d+)?$/
            const isNumber = isNumberRegex.test(value)
            if (isNumber && value > 90)
              return i18n.t(
                'fleet_management.geofences.create_geofence.rules.max_latitude'
              )
            else if (isNumber && value < -90)
              return i18n.t(
                'fleet_management.geofences.create_geofence.rules.min_latitude'
              )
            else if (!isNumber)
              //No es un número
              return i18n.t('fleet_management.geofences.coordinates.bad_format')
          }
          return result
        },
        longitude: value => {
          const regex = /^(\+|-)?(?:180(?:(?:\.0{1,7})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,7})?))$/
          const result = regex.test(value)
          if (!result) {
            const isNumberRegex = /^-?[0-9]\d*(\.\d+)?$/
            const isNumber = isNumberRegex.test(value)
            if (isNumber && value > 180)
              return i18n.t(
                'fleet_management.geofences.create_geofence.rules.max_longitude'
              )
            else if (isNumber && value < -180)
              return i18n.t(
                'fleet_management.geofences.create_geofence.rules.min_longitude'
              )
            else if (!isNumber)
              //No es un número
              return i18n.t('fleet_management.geofences.coordinates.bad_format')
          }
          return result
        }
      },
      errorName: '',
      geofenceValid: false,
      geofenceCreatedSuccessful: false,
      longitude: null,
      latitude: null,
      loading: false,
      maxRadius: GEOFENCE_MAX_RADIUS,
      minRadius: GEOFENCE_MIN_RADIUS,
      newGeofenceId: '',
      radius: null,
      radiusError: '',
      radiusRules: {
        required: value =>
          !!value ||
          i18n.t(
            'fleet_management.geofences.create_geofence.rules.field_required'
          ),
        range: value => {
          if (value > GEOFENCE_MAX_RADIUS)
            return i18n.t(
              'fleet_management.geofences.circular_geofence.rules.max_radius',
              {
                GEOFENCE_MAX_RADIUS
              }
            )
          else if (value < GEOFENCE_MIN_RADIUS)
            return i18n.t(
              'fleet_management.geofences.circular_geofence.rules.min_radius',
              {
                GEOFENCE_MIN_RADIUS
              }
            )
          else return !!value
        },
        format: value => {
          const regex = /^\d+$/
          return (
            regex.test(value) ||
            i18n.t('fleet_management.geofences.coordinates.bad_format')
          )
        }
      },
      valid: true
    }
  },
  methods: {
    ...mapActions('ui', ['setSnackbar']),

    resetCircleParams() {
      if (this.circle !== null) this.circle.setMap(null)
      this.circle = null
      this.latitude = null
      this.longitude = null
      this.radius = null
      this.radiusError = ''
      this.geofenceValid = false
      // this.$refs.form.resetValidation()
    },
    circleEmit() {
      const payload = {
        type: 'Feature',
        geometry: {
          type: 'Circle',
          coordinates: [Number(this.latitude), Number(this.longitude)],
          radius: Number(this.radius)
        },
        properties: {
          radius_units: 'm'
        }
      }
      this.$emit('circleEmit', [payload, true])
    },
    newCircleByInput() {
      this.geofenceValid = true
      const dataToCircle = {
        geometry: {
          coordinates: [this.latitude, this.longitude],
          radius: this.radius
        }
      }
      this.circle = GeofencesHelpers.showGeofenceOnMap(
        dataToCircle,
        'circle',
        true
      )
      GeofencesHelpers.getMap().fitBounds(this.circle.getBounds())
      google.maps.event.addListener(this.circle, 'radius_changed', () => {
        const circleRadius = Number(this.circle.getRadius().toFixed())
        if (circleRadius > GEOFENCE_MAX_RADIUS) {
          this.circle.setRadius(GEOFENCE_MAX_RADIUS)
          this.radius = GEOFENCE_MAX_RADIUS
        } else if (circleRadius < GEOFENCE_MIN_RADIUS) {
          this.circle.setRadius(GEOFENCE_MIN_RADIUS)
          this.radius = GEOFENCE_MIN_RADIUS
        } else this.radius = circleRadius
      })
      google.maps.event.addListener(this.circle, 'center_changed', () => {
        this.latitude = Number(
          this.circle
            .getCenter()
            .lat()
            .toFixed(7)
        )
        this.longitude = Number(
          this.circle
            .getCenter()
            .lng()
            .toFixed(7)
        )
      })
    },
    newCircle(data) {
      const lat = data.latLng.lat()
      const lng = data.latLng.lng()
      this.latitude = Number(lat.toFixed(7))
      this.longitude = Number(lng.toFixed(7))
      this.geofenceValid = true
      // Se calcula los bordes del mapa para poder calcular cuanto mide en metros a lo largo y a lo alto para poder hacer que el  circulo nuevo tenga las dimensiones acordes para entrar en el viewport del mapa y no tener que modificar el zoom del mapa
      const map = GeofencesHelpers.getMap()
      const spherical = google.maps.geometry.spherical
      const bounds = map.getBounds()
      const cor1 = bounds.getNorthEast()
      const cor2 = bounds.getSouthWest()
      const cor3 = new google.maps.LatLng(cor1.lat(), cor2.lng())
      const width = spherical.computeDistanceBetween(cor1, cor3)
      // 0.5 means 50%
      const radius = Math.round((width / 2) * 0.5)
      this.radius = radius

      const dataToCircle = {
        geometry: {
          coordinates: [lat, lng],
          radius: radius
        }
      }
      this.circle = GeofencesHelpers.showGeofenceOnMap(
        dataToCircle,
        'circle',
        true
      )

      google.maps.event.addListener(this.circle, 'radius_changed', () => {
        const circleRadius = Number(this.circle.getRadius().toFixed())
        if (circleRadius > GEOFENCE_MAX_RADIUS) {
          this.circle.setRadius(GEOFENCE_MAX_RADIUS)
          this.radius = GEOFENCE_MAX_RADIUS
        } else if (circleRadius < GEOFENCE_MIN_RADIUS) {
          this.circle.setRadius(GEOFENCE_MIN_RADIUS)
          this.radius = GEOFENCE_MIN_RADIUS
        } else this.radius = circleRadius
      })
      google.maps.event.addListener(this.circle, 'center_changed', () => {
        this.latitude = Number(
          this.circle
            .getCenter()
            .lat()
            .toFixed(7)
        )
        this.longitude = Number(
          this.circle
            .getCenter()
            .lng()
            .toFixed(7)
        )
      })
    },
    updateLatitude(val) {
      if (val.indexOf(' ') == -1)
        if (!isNaN(val) && val !== '') {
          this.latitude = Number(parseFloat(val).toFixed(7))
          this.updateMapCircle()
        }
    },
    updateLongitude(val) {
      if (val.indexOf(' ') == -1)
        if (!isNaN(val) && val !== '') {
          this.longitude = Number(parseFloat(val).toFixed(7))
          this.updateMapCircle()
        }
    },
    updateRadius(val) {
      //Círculo creado?
      if (this.circle !== null) {
        if (
          this.radius >= GEOFENCE_MIN_RADIUS &&
          this.radius <= GEOFENCE_MAX_RADIUS
        )
          this.circle.setRadius(Number(val))
        this.updateMapCircle()
      }
    },
    updateMapCircle() {
      const latitudeHasError = this.$refs.latitude.validate()
      const longitudeHasError = this.$refs.longitude.validate()
      const radiusHasError = this.$refs.radius.validate()
      if (latitudeHasError && longitudeHasError && radiusHasError) {
        this.geofenceValid = true
        //Si los inputs no presentan errores tengo que crear o actualizar el mapa
        //Circulo Creado
        if (this.circle !== null) {
          const center = new google.maps.LatLng(this.latitude, this.longitude)
          this.circle.setCenter(center)
          GeofencesHelpers.getMap().fitBounds(this.circle.getBounds())
        } else {
          //Circulo no creado
          this.newCircleByInput()
        }
      }
    }
  },
  mounted() {
    document.getElementsByClassName('v-text-field__slot')[1].id = "idZonasLatitud"
    document.getElementsByClassName('v-text-field__slot')[2].id = "idZonasLongitud"
    document.getElementsByClassName('v-text-field__slot')[3].id = "idZonasRadio"
    this.$nextTick(function() {
      const map = GeofencesHelpers.getMap()

      MapHelpers.setMapCenterBaseOnCountryId()

      google.maps.event.addListener(map, 'click', event => {
        if (this.circle === null) {
          this.newCircle(event)
        }
      })
    })
  },
  beforeDestroy() {
    if (this.circle !== null) {
      this.circle.setMap(null)
    }
    const map = GeofencesHelpers.getMap()
    google.maps.event.clearListeners(map, 'click')
  },
  watch: {
    longitude() {
      this.circleEmit()
    },
    latitude() {
      this.circleEmit()
    },
    radius() {
      this.circleEmit()
    }
  }
}
</script>

<style></style>
